// extracted by mini-css-extract-plugin
export default {"background":"MenuLayout_background__AQVKr"};